import { graphql } from "./gql";

export const ASSET_FRAGMENT = graphql(`
    fragment Asset on Asset {
        id
        preview
        width
        height
        focalPoint {
            x
            y
        }
    }
`);

export const CART_FRAGMENT = graphql(`
    fragment Cart on Order {
        id
        code
        state
        active
        couponCodes
        orderPlacedAt
        lines {
            id
            updatedAt
            featuredAsset {
                ...Asset
            }
            colourChartProductAssetPreview
            unitPrice
            unitPriceWithTax
            discountedUnitPriceWithTax
            quantity
            linePriceWithTax
            discountedLinePriceWithTax
            productVariant {
                id
                name
                sku
                product {
                    id
                    slug
                    customFields {
                        pageType
                        minimumOrderQuantity
                    }
                    shippingRestrictions
                }
            }
            discounts {
                type
                amount
                amountWithTax
                description
            }
            customFields {
                addedFromWishlistCustomerName
                addedFromWishlistName
                freeGiftDescription
            }
            giftCardInput {
                value
                senderName
                recipientEmailAddress
                message
                deliveryDate
                templateId
                templateName
            }
        }
        mergedOrderLines {
            orderLineId
            quantityAdded
        }
        subTotal
        subTotalWithTax
        shipping
        shippingWithTax
        shippingLines {
            shippingMethod {
                id
                name
            }
            discounts {
                description
                amount
                amountWithTax
            }
            priceWithTax
            discountedPriceWithTax
        }
        shippingAddress {
            country
            countryCode
        }
        total
        totalWithTax
        totalWithTaxAfterGiftCard
        giftCardsApplied {
            balance
            code
        }
        currencyCode
        discounts {
            amount
            amountWithTax
            description
        }
        customFields {
            rewardPointsUsed
            referralCode
            referredBy
        }
    }
`);

export const ACTIVE_CUSTOMER_FRAGMENT = graphql(`
    fragment ActiveCustomer on Customer {
        id
        title
        firstName
        lastName
        emailAddress
        phoneNumber
        customFields {
            rewardPointsTotal
            newsletterOptIn
            catalogueOptIn
            reviewEmailOptIn
        }
    }
`);

export const COUNTRY_FRAGMENT = graphql(`
    fragment Country on Country {
        id
        code
        name
        enabled
    }
`);

export const ORDER_ADDRESS_FRAGMENT = graphql(`
    fragment OrderAddress on OrderAddress {
        fullName
        company
        streetLine1
        streetLine2
        city
        province
        postalCode
        country
        countryCode
        phoneNumber
        customFields {
            deliveryInstructions
            streetLine3
            firstName
            lastName
        }
    }
`);

export const ADDRESS_FRAGMENT = graphql(`
    fragment Address on Address {
        id
        fullName
        company
        streetLine1
        streetLine2
        city
        province
        postalCode
        country {
            id
            code
            name
        }
        phoneNumber
        defaultShippingAddress
        defaultBillingAddress
        customFields {
            streetLine3
            deliveryInstructions
            firstName
            lastName
        }
    }
`);

export const ERROR_RESULT_FRAGMENT = graphql(`
    fragment ErrorResult on ErrorResult {
        errorCode
        message
    }
`);

export const SEARCH_RESULT_FRAGMENT = graphql(`
    fragment SearchResult on SearchResult {
        id
        productId
        sku
        slug
        productName
        description
        priceWithTax {
            ... on PriceRange {
                min
                max
            }
        }
        customMappings {
            reviewRating
            reviewCount
            offers
            rrp {
                min
                max
            }
            rrpDiscount
        }
        productAsset {
            id
            preview
            focalPoint {
                x
                y
            }
        }
        productVariantAsset {
            id
            preview
            focalPoint {
                x
                y
            }
        }
        highlights {
            field
            snippet
        }
    }
`);

export const ORDER_DETAIL_FRAGMENT = graphql(`
    fragment OrderDetail on Order {
        ...Cart
        rewardPointsEarned
        payments {
            amount
            method
            state
            metadata
            refunds {
                reason
                method
                state
                total
            }
        }
        shippingAddress {
            ...OrderAddress
        }
        billingAddress {
            ...OrderAddress
        }
    }
`);
